@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.browser.http.http
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.hasClass
import kotlinx.dom.removeClass
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.EventSource
import org.w3c.dom.EventSourceInit
import org.w3c.dom.MessageEvent
import org.w3c.dom.`get`
import com.devsusana.portfolio.components.layouts.ArticleLayout as _com_devsusana_portfolio_components_layouts_ArticleLayout
import com.devsusana.portfolio.pages.HomePage as _com_devsusana_portfolio_pages_HomePage
import com.devsusana.portfolio.pages.posts.AndroidMemoryEngineeringLlmPage as _com_devsusana_portfolio_pages_posts_AndroidMemoryEngineeringLlmPage
import com.devsusana.portfolio.pages.posts.BuildingHomeTutorProPage as _com_devsusana_portfolio_pages_posts_BuildingHomeTutorProPage
import com.devsusana.portfolio.pages.posts.BuildingHomeTutorProPageEs as _com_devsusana_portfolio_pages_posts_BuildingHomeTutorProPageEs
import com.devsusana.portfolio.pages.posts.HybridPatternMobileAiPage as _com_devsusana_portfolio_pages_posts_HybridPatternMobileAiPage
import com.devsusana.portfolio.pages.posts.OnDeviceAiLocalRagAndroidPage as _com_devsusana_portfolio_pages_posts_OnDeviceAiLocalRagAndroidPage
import com.devsusana.portfolio.pages.posts.es.AndroidMemoryEngineeringLlmPageEs as _com_devsusana_portfolio_pages_posts_es_AndroidMemoryEngineeringLlmPageEs
import com.devsusana.portfolio.pages.posts.es.HybridPatternMobileAiPageEs as _com_devsusana_portfolio_pages_posts_es_HybridPatternMobileAiPageEs
import com.devsusana.portfolio.pages.posts.es.OnDeviceAiLocalRagAndroidPageEs as _com_devsusana_portfolio_pages_posts_es_OnDeviceAiLocalRagAndroidPageEs

private fun forceReloadNow() {
    window.stop()
    window.location.reload()
}

private fun handleServerStatusEvents() {
    val status = document.getElementById("status")!!
    var lastVersion: Int? = null
    var shouldReload = false

    val warningIcon = status.children[0]!!
    val spinnerIcon = status.children[1]!!
    val statusText = status.children[2]!!

    status.addEventListener("transitionend", {
        if (status.hasClass("fade-out")) {
            status.removeClass("fade-out")
            if (shouldReload) {
                forceReloadNow()
            }
        }
    })

    val eventSource = EventSource("/api/kobweb-status", EventSourceInit(true))
    eventSource.addEventListener("version", { evt ->
        val version = (evt as MessageEvent).data.toString().toInt()
        if (lastVersion == null) {
            lastVersion = version
        }
        if (lastVersion != version) {
            lastVersion = version
            if (document.asDynamic().hidden) {
                // Reload immediately when the page is not visible as the animation will not run
                forceReloadNow()
            } else if (status.className.isNotEmpty()) {
                shouldReload = true
            } else {
                // Not sure if we can get here but if we can't rely on the status transition
                // to reload we should do it ourselves.
                forceReloadNow()
            }
        }
    })

    eventSource.addEventListener("status", { evt ->
        val values: dynamic = JSON.parse<Any>((evt as MessageEvent).data.toString())
        val text = values.text as String
        val isError = (values.isError as String).toBoolean()
        if (text.isNotBlank()) {
            warningIcon.className = if (isError) "visible" else "hidden"
            spinnerIcon.className = if (isError) "hidden" else "visible"
            statusText.innerHTML = "<i>$text</i>"
            status.className = "fade-in"
        } else {
            if (status.className == "fade-in") {
                status.className = "fade-out"
            }
        }
    })

    eventSource.onerror = { eventSource.close() }
}

public fun main() {
    handleServerStatusEvents()

    window.http.logOnError = true

    AppGlobals.initialize(mapOf("title" to "Susana Córdoba | Senior Android Engineer & Tech Lead"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.devsusana.portfolio.components.layouts.ArticleLayout",
        ) { pageCtx, pageMethod -> 
            _com_devsusana_portfolio_components_layouts_ArticleLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_HomePage()
        }
        ctx.router.register(
            "/posts/android-memory-engineering-llm",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_AndroidMemoryEngineeringLlmPage()
        }
        ctx.router.register(
            "/posts/building-home-tutor-pro",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_BuildingHomeTutorProPage()
        }
        ctx.router.register(
            "/posts/es/android-memory-engineering-llm",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_es_AndroidMemoryEngineeringLlmPageEs()
        }
        ctx.router.register(
            "/posts/es/building-home-tutor-pro",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_BuildingHomeTutorProPageEs()
        }
        ctx.router.register(
            "/posts/es/hybrid-pattern-mobile-ai",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_es_HybridPatternMobileAiPageEs()
        }
        ctx.router.register(
            "/posts/es/on-device-ai-local-rag-android",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_es_OnDeviceAiLocalRagAndroidPageEs()
        }
        ctx.router.register(
            "/posts/hybrid-pattern-mobile-ai",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_HybridPatternMobileAiPage()
        }
        ctx.router.register(
            "/posts/on-device-ai-local-rag-android",
        ) { pageCtx -> 
            _com_devsusana_portfolio_pages_posts_OnDeviceAiLocalRagAndroidPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        com.devsusana.portfolio.initColorMode(ctx)
        com.devsusana.portfolio.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.devsusana.portfolio.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
